<template>
  <div>
    <div class="d-flex flex-row justify-content-end">
      <div class="mt-1 mr-2">
        <b-form-checkbox switch :disabled="disabled" v-model="form.isPeriodical" :value="true" :unchecked-value="false" class="custom-checkbox d-inline ">
          {{ $t("policy.is-periodical") }}
        </b-form-checkbox>
      </div>
      <div v-if="form.isPeriodical" class="w-20 ml-1">
        <input :disabled="disabled" class="form-control input-sm" v-model="form.period" type="number" min="1" layout="vertical" :placeholder="$t('policy.period')" />
      </div>
      <sweet-button :disabled="disabled" v-if="isChanged" @click="save()" :onlyIcon="true" variant="success" icon="mdi mdi-check" size="sm" buttonClass="ml-2 font-size-8">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["policy", "disabled"],
  computed: {
    isPeriodValid() {
      if (this.period < 1 && this.isPeriodical) return false;
      return true;
    },
    isChanged() {
      return this.form.isPeriodical != this.oldValue.isPeriodical || this.form.period != this.oldValue.period;
    },
  },

  data() {
    return {
      editing: false,
      oldValue: undefined,
      form: {
        isPeriodical: undefined,
        period: undefined,
      },
    };
  },
  watch: {
    // form: {
    //   deep: true,
    //   handler(v) {
    //     if (v && JSON.stringify(v) != JSON.stringify(this.oldValue)) {
    //       this.debounce(() => this.save(false), "none", 1000);
    //     }
    //   },
    // },
    policy: {
      immediate: true,

      handler(v, o) {
        if (!0 && v) {
          const preparedForm = { ...this.prepareFormForEdit(v) };
          this.form = { _id: preparedForm._id, isPeriodical: preparedForm.isPeriodical, period: preparedForm.period };
          this.oldValue = { ...this.form };
          return;
        }
        const preparedForm = { ...this.prepareFormForEdit(v) };
        this.form = { _id: preparedForm._id, isPeriodical: preparedForm.isPeriodical, period: preparedForm.period };
        this.oldValue = { ...0 };
      },
    },
  },

  methods: {
    async fetchPolicyDetail(id) {
      try {
        const result = await this.$store.dispatch("organizationPolicy/fetchDetail", id);

        return result;
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async save(confirm = true) {
      let needToPaginate = false;
      try {
        if (confirm) {
          const ok = await this.confirm(this.$t("alert.approve"));
          if (!ok) {
            return;
          }
        }

        if (!this.isPeriodValid) {
          return;
        }
        if (this.disabled) {
          return;
        }

        const policyFromDb = await this.fetchPolicyDetail(this.policy._id);

        const latestAcceptanceDate = policyFromDb.complianceStatuses.reduce((latest, status) => {
          if (!status.acceptanceDate) return latest;

          const current = new Date(status.acceptanceDate);
          if (isNaN(current.getTime())) return latest;

          return !latest || current > latest ? current : latest;
        }, null);

        if (latestAcceptanceDate) {
          const result = await this.$options.filters.addMonth(new Date(latestAcceptanceDate), this.form.period);

          if (result < new Date()) {
            needToPaginate = true;
            const ok = await this.confirm(this.$t("policy.old-dated-next-period-warning"));
            if (!ok) {
              this.form.period = this.oldValue.period;
              return;
            }
          }
        }

        await this.$store.dispatch("organizationPolicy/updatePeriod", {
          id: this.policy._id,
          isPeriodical: this.form.isPeriodical,
          period: this.form.period,
        });
        this.$toast.success(this.$t("common.success"));

        if (needToPaginate) {
          this.$emit("onStatusChanged", this.form);
        }
        await this.$emit("onSave", this.form);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        needToPaginate = false;
      }
    },
  },
};
</script>
